/* global axios */

import ApiClient from './ApiClient';

class DatabaseExportAPI extends ApiClient {
  constructor() {
    super('database_export', { accountScoped: true });
  }

  create() {
    return axios.post(this.url, {}, { responseType: 'blob' });
  }
}

export default new DatabaseExportAPI();
